document.querySelectorAll('[data-bed-catalog]').forEach(async root => {
  const grid = root.querySelector('[data-bed-grid]');
  const cards = [...root.querySelectorAll('[data-variant-id]')];
  const filters = [...root.querySelectorAll('[data-bed-filter]')];
  const sort = root.querySelector('[data-bed-sort]');
  const countTemplate = root.querySelector('[data-bed-count-template]').content.textContent;
  for (const filter of filters) {
    if (filter.dataset.bedFilter === 'stock') continue;
    const values = [...new Set(cards.map(card => card.dataset[filter.dataset.bedFilter]).filter(Boolean))];
    values.sort((a, b) => a.localeCompare(b, 'en', { numeric: true }));
    for (const value of values) filter.add(new Option(value, value));
    if (values.length < 2) filter.closest('label').hidden = true;
  }
  let sourceOrder = {};
  const update = () => {
    let count = 0;
    const ordered = [...cards];
    if (sort.value === 'featured') ordered.sort((a,b) => (sourceOrder[a.dataset.variantId] ?? 9999) - (sourceOrder[b.dataset.variantId] ?? 9999));
    if (sort.value !== 'featured') ordered.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * (sort.value === 'price-descending' ? -1 : 1));
    for (const card of ordered) {
      card.hidden = !filters.every(filter => !filter.value || card.dataset[filter.dataset.bedFilter] === filter.value);
      if (!card.hidden) count += 1;
      grid.append(card);
    }
    root.querySelector('[data-bed-count]').textContent = countTemplate.replace('[count]', String(count));
    root.querySelector('[data-bed-no-results]').hidden = count !== 0;
  };
  filters.forEach(filter => filter.addEventListener('change', update));
  sort.addEventListener('change', update);
  root.querySelector('[data-bed-reset]').addEventListener('click', () => {
    filters.forEach(filter => { filter.value = ''; });
    sort.value = 'featured';
    update();
  });
  try {
    if (root.dataset.ordersUrl) {
      const ordersResponse = await fetch(root.dataset.ordersUrl);
      if (ordersResponse.ok) sourceOrder = (await ordersResponse.json())[root.dataset.sourceCollection] || {};
    }
    const response = await fetch(root.dataset.stockUrl);
    if (!response.ok) throw new Error('Stock information unavailable');
    const stock = await response.json();
    for (const card of cards) {
      const state = stock[card.dataset.variantId];
      if (!state) continue;
      card.dataset.stock = state.status;
      const message = card.querySelector('[data-bed-choice-stock]');
      const date = state.date ? new Date(`${state.date}T12:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' }) : '';
      message.textContent = state.status === 'out' ? root.dataset.out : state.status === 'preorder' ? root.dataset.preorder.replace('[date]', date) : '';
      message.hidden = !message.textContent;
    }
  } catch (error) {
    console.warn('Bed availability could not be refreshed', error);
  }
  update();
});
